/* jshint esversion: 6, -W097 */
/* globals require */
'use strict';


function checkboxesFilterDirective() {

    return {
        // must be an element (can not be used as an attribute or ...)
        restrict: 'E',
        scope: {
            code: '=',
            isFullWidth: '=',
            options: '='
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: checkboxesFilter,
        template: require('./checkboxesFilterView.html')
    };
}

checkboxesFilter.$inject = [
    'FiltersService',
];
function checkboxesFilter(
    FiltersService,
) {

    this.$onInit = () => {
        const vm = this;

        // Pre-populates the filter
        if (vm.code in FiltersService.initialFiltersData) {
            prePopulateFilter(vm.code);
        }

        vm.isReady = () => {
            return !FiltersService.lockFilters;
        };

        // Hides extra options
        vm.maxShownCheckboxesByDefault = 7;
        vm.allOptionsShown = false;
        hideExtraOptions();

        vm.isNewFiltersEnabled = FiltersService.isNewFiltersEnabled;

        // Registers the filter output and reset callbacks
        FiltersService.filtersOutputCallbacks.push({
            'filter_output': filterOutput
        });
        FiltersService.filtersResetCallbacks.push({
            filterKey: vm.code,
            callback: filterReset
        });

        /**
         * On checkbox change, we want to update the results quantity based on the latest state of the filters
         *
         */
        vm.checkboxChanged = (urlValue) => {
            FiltersService.trackProductFiltersEngaged(filterOutput());
            FiltersService.checkFilterAutoToggles(urlValue);
            if (vm.isNewFiltersEnabled) {
                FiltersService.getResultsOnChange();
            }
        };

        vm.toggleAllOptions = toggleAllOptions;
        vm.hasExtraOptions = hasExtraOptions;

        /**
         * Pre-populates the filter from FiltersService.initialFiltersData
         *
         * @param code
         */
        function prePopulateFilter(code) {
            let preSelectedChoices = FiltersService.initialFiltersData[code];
    
            vm.options.values.forEach((value) => {
                value.is_checked = false;
            });
    
            if (!Array.isArray(preSelectedChoices)) {
                preSelectedChoices = [preSelectedChoices];
            }
    
            preSelectedChoices.forEach((selectedChoice) => {
                vm.options.values.forEach((value) => {
                    if (value.display_name.toString().toLowerCase() === selectedChoice.toLowerCase()) {
                        value.is_checked = true;
                    }
                });
            });
        }
    
        /**
         * Outputs the filter's user inputs in form of a single-level key values dictionary
         *
         * @returns {'filter_code', 'filter_value'}
         */
        function filterOutput() {
            const output = {};
            output[vm.options.url_value] = [];
    
            vm.options.values.forEach((value) => {
                if (value.is_checked) {
                    output[vm.options.url_value].push(value.url_value);
                }
            });
    
            if (output[vm.options.url_value].length === 0) {
                output[vm.options.url_value] = null;
            }
    
            return output;
        }

        function filterReset(valueToRemove) {
            vm.options.values.forEach((value) => {
                if (valueToRemove === null || value.display_name === valueToRemove) {
                    value.is_checked = false;
                }
            });
        }

        function hideExtraOptions() {
            vm.shownOptions = vm.options.values.slice(0, vm.maxShownCheckboxesByDefault);
        }

        /**
         * Whether or not it has extra options
         *
         * @returns {boolean} whether or not the view all options should be shown
         */
        function hasExtraOptions() {
            return vm.options.values && (vm.options.values.length > vm.maxShownCheckboxesByDefault);
        }

        /**
         * Shows all checkbox options after clicking on the view all options
         */
        function toggleAllOptions() {
            vm.allOptionsShown = !vm.allOptionsShown;
            if (vm.allOptionsShown) {
                vm.shownOptions = vm.options.values;
            } else {
                vm.shownOptions = vm.options.values.slice(0, vm.maxShownCheckboxesByDefault);
            }
        }
    };

}

module.exports = checkboxesFilterDirective;